"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SemanticErrorCodes = void 0;
var SemanticErrorCodes;
(function (SemanticErrorCodes) {
    SemanticErrorCodes["FUNCTION_NOT_FOUND"] = "FUNCTION_NOT_FOUND";
    SemanticErrorCodes["TOKEN_NOT_INDENTIFIED"] = "TOKEN_NOT_INDENTIFIED";
    SemanticErrorCodes["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
    SemanticErrorCodes["INVALID_DATA_TYPE"] = "INVALID_DATA_TYPE";
    SemanticErrorCodes["MISSING_ARGUMENTS"] = "MISSING_ARGUMENTS";
    SemanticErrorCodes["UNEXPECTED_ENUM"] = "UNEXPECTED_ENUM";
    SemanticErrorCodes["WINDOW_FUNCTION_NOT_ROOT"] = "WINDOW_FUNCTION_NOT_ROOT";
    SemanticErrorCodes["WINDOW_FUNCTION_INVALID_DATA_TYPE"] = "WINDOW_FUNCTION_INVALID_DATA_TYPE";
    SemanticErrorCodes["INVALID_BOOLEAN_COMPARISON"] = "INVALID_BOOLEAN_COMPARISON";
    SemanticErrorCodes["FOREIGN_REFERENCE_MULTIPLES_TABS"] = "FOREIGN_REFERENCE_MULTIPLES_TABS";
})(SemanticErrorCodes = exports.SemanticErrorCodes || (exports.SemanticErrorCodes = {}));
